import { useEffect, useState } from 'react';

import { useIsDesktop } from '@/hooks';

export function useGetVideoAndImageSource() {
  const isDesktop = useIsDesktop();
  const videoSource = isDesktop
    ? '/hanghae99/landing/hub/hh_hub_bg_flame_pc.mp4'
    : '/hanghae99/landing/hub/hh_hub_bg_flame_mo.mp4';

  const videoThumbnailSource = isDesktop
    ? '/hanghae99/landing/hub/hh_hub_bg_flame_pc.webp'
    : '/hanghae99/landing/hub/hh_hub_bg_flame_mo.webp';

  return {
    videoSource,
    videoThumbnailSource,
  };
}

export function useIsRendered() {
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    setIsRendered(true);
  }, []);

  return { isRendered };
}
